import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseHttpService } from "./base.http.service";
import { Testemonial } from "../types/testemonial";

@Injectable({
  providedIn: "root",
})
export class TestemonialService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  private apiUrlWithEndpoint(endpoint: string): string {
    return `${this.apiUrl}/api/Testemonials/${endpoint}`;
  }

  getTestemonial(testemonialId: number): Observable<Testemonial> {
    return this.http.get<Testemonial>(this.apiUrlWithEndpoint(`${testemonialId}`));
  }

  addTestemonial(testemonialData: any, files: File[]): Observable<Testemonial> {
    const formData = new FormData();
    formData.append("title", testemonialData.title);
    formData.append("content", testemonialData.content);
    formData.append("categoryId", testemonialData.categoryId.toString());
    formData.append("languageId", testemonialData.languageId.toString());

    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }

    return this.http.post<Testemonial>(this.apiUrlWithEndpoint(""), formData);
  }

  updateTestemonial(testemonialId: number, testemonialData: any, files: File[]): Observable<Testemonial> {
    const formData = new FormData();
    formData.append("title", testemonialData.title);
    formData.append("content", testemonialData.content);
    formData.append("categoryId", testemonialData.categoryId.toString());
    formData.append("languageId", testemonialData.languageId.toString());

    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }

    return this.http.put<Testemonial>(this.apiUrlWithEndpoint(`${testemonialId}`), formData);
  }

  deleteTestemonial(testemonialId: number): Observable<any> {
    return this.http.delete(this.apiUrlWithEndpoint(`${testemonialId}`));
  }
}
